import { NavItem } from './types';

const navItems: NavItem[] = [
  {
    label: 'Home',
    href: 'https://www.amazinggaming.com/'
  },
  {
    label: 'Products',
    children: [
      {
        label: 'Sportsbook',
        to: 'products',
        hash: 'sportsbook_product',
        color: 'success'
      },
      {
        label: 'Live Casino',
        to: 'products',
        hash: 'livecasino_product',
        color: 'primary'
      },
      {
        label: 'Slot Games',
        to: 'products',
        hash: 'slots_product',
        color: 'info'
      },
      {
        label: 'Fish Hunter',
        to: 'products',
        hash: 'fishhunter_product',
        color: 'warning'
      }
    ]
  },
  {
    label: 'Live Casino',
    to: 'live_casino_games'
  },
  {
    label: 'Casino',
    to: 'casino_games'
  }
];

export default navItems;
